import React from 'react'

import Header from './header'
import Nav from './nav'

export default ({ children }) => [
  <Header key="header" />,
  <div key="content-wrap" className="content-wrap">
    <div className="content">
      <Nav />
      <div className="tab-content">{children}</div>
    </div>
  </div>
]



// WEBPACK FOOTER //
// ./src/containers/layouts/default/index.js